module.exports = __webpack_public_path__ + "29dcd43018bb8b29ca63324fd09971aa.jpg";